module.exports = __webpack_public_path__ + "img/bank.fbeb10f9.svg";